export default __webpack_public_path__ + "static/media/100_38802.ed9b1a65.jpg";